export const ColumnIds = {
  selector: 'selector',
  options: 'options',

  quotationsTitle: 'quotations_title',
  quotationsBrand: 'quotations_brand',
  quotationsClient: 'quotations_client',
  quotationsDocDate: 'quotations_doc_date',
  quotationsDocYear: 'quotations_doc_year',
  quotationsDocQuarter: 'quotations_doc_quarter',
  quotationsStatus: 'quotations_status',
  quotationsTotal: 'quotations_total',
  quotationsMobile: 'quotations_mobile',

  invoicesTitle: 'invoices_title',
  invoicesBrand: 'invoices_brand',
  invoicesClient: 'invoices_client',
  invoicesDocDate: 'invoices_doc_date',
  invoicesDocYear: 'invoices_doc_year',
  invoicesDocQuarter: 'invoices_doc_quarter',
  invoicesStatus: 'invoices_status',
  invoicesTotal: 'invoices_total',
  invoicesAdvantage: 'invoices_advantage',
  invoicesMobile: 'invoices_mobile',

  creditNotesDescription: 'credit_notes_description',
  creditNotesBrand: 'credit_notes_brand',
  creditNotesClient: 'credit_notes_client',
  creditNotesDocDate: 'credit_notes_doc_date',
  creditNotesDocYear: 'credit_notes_doc_year',
  creditNotesDocQuarter: 'credit_notes_doc_quarter',
  creditNotesReason: 'credit_notes_reason',
  creditNotesStatus: 'credit_notes_status',
  creditNotesTotal: 'credit_notes_total',
  creditNotesMobile: 'credit_notes_mobile',

  invoiceTemplatesTitle: 'invoice_templates_title',
  invoiceTemplatesClient: 'invoice_templates_client',
  invoiceTemplatesType: 'invoice_templates_type',
  invoiceTemplatesNextInvoice: 'invoice_templates_next_invoice',
  invoiceTemplatesTotal: 'invoice_templates_total',
  invoiceTemplatesBrand: 'invoice_templates_brand',
  invoiceTemplatesMobile: 'invoice_templates_mobile',

  productsName: 'products_name',
  productsStatus: 'products_status',
  productsActivityType: 'products_activity_type',
  productsPrice: 'products_price',
  productsCategories: 'products_categories',
  productsMobile: 'products_mobile',

  clientsName: 'clients_name',
  clientsType: 'clients_type',
  clientsVat: 'clients_vat',
  clientsContacts: 'clients_contacts',
  clientsMobile: 'clients_mobile',

  contactsName: 'contacts_name',
  contactsEmail: 'contacts_email',
  contactsPhoneNumber: 'contacts_phone_number',
  contactsMobile: 'contacts_mobile',

  brandsLogo: 'brands_logo',
  brandsName: 'brands_name',
  brandsEmail: 'brands_email',
  brandsColor: 'brands_color',
  brandsMobile: 'brands_mobile',

  numberingSeriesName: 'numbering_series_name',
  numberingSeriesType: 'numbering_series_type',
  numberingSeriesNextNumber: 'numbering_series_next_number',
  numberingSeriesMobile: 'numbering_series_mobile',

  customConditionsName: 'custom_conditions_name',
  customConditionsMobile: 'custom_conditions_mobile',

  documentLinesDescription: 'document_lines_description',
  documentLinesQuantity: 'document_lines_quantity',
  documentLinesPrice: 'document_lines_price',
  documentLinesDiscount: 'document_lines_discount',
  documentLinesVat: 'document_lines_vat',
  documentLinesTotal: 'document_lines_total',
  documentLinesMobile: 'document_lines_mobile',

  documentsName: 'documents_name',
  documentsExtension: 'documents_extension',
  documentsDownload: 'documents_download',
  documentsMobile: 'documents_mobile',

  invitationsName: 'invitations_name',
  invitationsEmail: 'invitations_email',
  invitationsStatus: 'invitations_status',
  invitationsMobile: 'invitations_mobile',
} as const;
